export const SERVER_URL = "https://do-calculate.com/api";

export const Period_EndPoint = "calculate-period";
export const Conception_EndPoint = "calculate-conception";
export const Ovulation_EndPoint = "calculate-ovulation";
export const DueDate_EndPoint = "calculate-due-date";
export const PregnancyConception_EndPoint = "calculate-pregnancy-conception";
export const WeightGainPregnancyCalculate_EndPoint =
  "calculate-pregnancy-weight-gain";
export const PregnancyCalculate_EndPoint = "calculate-pregnancy";
export const womenCalculators = [
  {
    name: "Calculatrice des règles",
    link: "/calculator/fr/period/",
    description:
      "Cette calculatrice aide à suivre le cycle menstruel et à identifier les périodes fertiles.",
    showMain: true,
  },
  {
    name: "Calculatrice de grossesse",
    link: "/calculator/fr/pregnancy/",
    description:
      "Utilisez cette calculatrice pour calculer la date prévue de conception et estimer la semaine de grossesse actuelle.",
    showMain: true,
  },
  {
    name: "Calculatrice de date de conception",
    link: "/calculator/fr/pregnancy-conception/",
    description: "Cette calculatrice calcule la date de conception pendant la grossesse.",
    showMain: true,
  },
  {
    name: "Calculatrice de date prévue d'accouchement",
    link: "/calculator/fr/pregnancy-due-date/",
    description:
      "Utilisez cette calculatrice pour estimer la date d'accouchement prévue en fonction de la date du début de la grossesse.",
    showMain: true,
  },
  {
    name: "Calculatrice d'ovulation",
    link: "/calculator/fr/ovulation/",
    description: "Cette calculatrice aide à estimer la date d'ovulation et la meilleure période pour la conception.",
    showMain: true,
  },
  {
    name: "Calculatrice de conception",
    link: "/calculator/fr/conception/",
    description:
      "Utilisez cette calculatrice pour calculer la date de conception en fonction de la date de vos dernières règles et de la durée de votre cycle.",
    showMain: true,
  },
  {
    name: "Calculatrice de taille de soutien-gorge",
    link: "/calculator/fr/bra_size_calculator/",
    description:
      "Utilisez cette calculatrice pour calculer la date de conception en fonction de la date de vos dernières règles et de la durée de votre cycle.",
    showMain: true,
  },
];
export default womenCalculators;